import styled from 'styled-components';

export const StyledText = styled.div.withConfig({
  shouldForwardProp: (prop) => !['color', 'mt', 'mb'].includes(prop),
})`
  color: ${(props) => props.color};
  margin-top: ${(props) => props.mt}px;
  margin-bottom: ${(props) => props.mb}px;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.focusRing};
    outline-offset: -2px;
    border-radius: 4px;
  }

  legend&:not(.text-center) {
    max-width: fit-content;
  }

  &.h1,
  &.h-modal {
    font-weight: 700;
    font-size: 36px;
  }

  &.h1-5 {
    font-weight: 700;
    font-size: 32px;
  }

  &.h2 {
    font-weight: 600;
    font-size: 24px;
  }

  &.h2-5 {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
  }

  &.h3 {
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
  }

  &.h3-5 {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }

  &.h5 {
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
  }

  &.b1 {
    font-size: 24px;
  }

  &.b2 {
    font-size: 20px;
  }

  &.b3 {
    font-size: 18px;
  }

  &.b4 {
    font-size: 16px;
  }

  &.b5 {
    font-size: 14px;
  }

  &.link {
    color: ${(props) => props.theme.colors.title};
    cursor: pointer;

    &:hover {
      color: ${(props) => props.theme.colors.btnHover};
    }

    &:focus {
      color: ${(props) => props.theme.colors.btnHover};
    }
  }
  &.news-body p {
    margin: 1rem 0;
  }

  a {
    color: ${(props) => props.theme.colors.title};
    font-weight: 700;
    transition: ${(props) => props.theme.constants.transitionBase};

    &:hover {
      color: ${(props) => props.theme.colors.btnHover};
    }

    &:focus {
      color: ${(props) => props.theme.colors.btnHover};
    }
  }

  b {
    font-weight: 600;
  }

  &.statistics-heading {
    color: ${(props) => props.theme.colors.primaryDarkGray700};
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    text-transform: uppercase;
  }

  @media ${(props) => props.theme.device.tabletL} {
    &.h1,
    &.h-modal {
      font-weight: 700;
      font-size: 32px;
    }

    &.h1-5 {
      font-weight: 600;
      font-size: 32px;
    }

    &.h2 {
      font-weight: 600;
      font-size: 24px;
    }

    &.h2-5 {
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
    }

    &.h3 {
      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
    }

    &.h3-5 {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
    }

    &.h5 {
      font-size: 14px;
      font-weight: 700;
      line-height: 16px;
    }

    &.b1 {
      font-size: 24px;
      font-weight: 400;
    }

    &.b2 {
      font-size: 20px;
      font-weight: 400;
    }

    &.b3 {
      font-size: 18px;
      font-weight: 400;
    }

    &.b4 {
      font-size: 16px;
      font-weight: 400;
    }

    &.b5 {
      font-size: 14px;
      font-weight: 400;
    }
  }
`;
